import { Theme } from '@mui/material';
import { axisClasses, chartsGridClasses, legendClasses } from '@mui/x-charts';

import { themeBase } from '../theme-base';

const { spacing, palette } = themeBase;

// MUI X Charts v8 compatible theme configuration
export const muiCharts: Theme['components'] = {
  MuiChartsSurface: {
    styleOverrides: {
      root: {
        borderRadius: spacing(2),
        background: '#0F151C',
      },
    },
  },
  MuiChartsLegend: {
    styleOverrides: {
      root: {
        [`.${legendClasses.series}`]: {
          color: 'white',
          text: {
            fill: 'currentColor',
          },
        },
      },
    },
  },
  MuiChartsAxis: {
    styleOverrides: {
      root: {
        [`.${axisClasses.tickLabel}`]: {
          color: palette.grey[400],
          fill: 'currentColor',
        },
        [`.${axisClasses.label}`]: {
          color: palette.grey[400],
          fill: 'currentColor',
        },
        [`.${axisClasses.tick}`]: {
          stroke: palette.grey[400],
        },
      },
    },
  },
  MuiChartsGrid: {
    styleOverrides: {
      root: {
        background: '#0F151C',
        [`.${chartsGridClasses.verticalLine}`]: {
          strokeDasharray: '4 4',
        },
        [`.${chartsGridClasses.horizontalLine}`]: {
          strokeDasharray: '4 4',
        },
      },
      line: {
        color: palette.mapBlue[700],
        stroke: 'currentColor',
      },
    },
  },
  MuiChartsTooltip: {
    styleOverrides: {
      root: {
        backgroundColor: '#1A2027',
        borderColor: palette.grey[700],
      },
      table: {
        color: 'white',
      },
    },
  },
};
